import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { ContractWidget } from '../../../../models';
import { Contract } from '../../../../models/contract';
import { SharedModule } from '../../../../shared/shared.module';
import { PoolObject } from 'app/core/contract/poolObject.model';
import { ContractsService } from 'app/customer-portal';
import { B2bInsuredDeviceComponent } from '../../components/b2b-insured-device/b2b-insured-device.component';

@Component({
    selector: 'app-multiple-devices-widget',
    imports: [SharedModule, B2bInsuredDeviceComponent],
    templateUrl: './multiple-devices-widget.component.html',
    styleUrl: './multiple-devices-widget.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultipleDevicesWidgetComponent implements ContractWidget {
    public contract = input.required<Contract>();

    private contractService = inject(ContractsService);

    protected devices = computed(() => this.contract().objectPool);

    public submit(updatedDevices: PoolObject[]): void {
        const poolObjects = this.contract().objectPool.map((item: PoolObject) => {
            const matchingItem = updatedDevices.find((updatedItem) => item.Id === updatedItem.Id);
            if (matchingItem) {
                return { ...item, ObjectDetail: matchingItem.ObjectDetail };
            } else {
                return item;
            }
        });
        this.contractService.updateInsuredObjects(this.contract().id, poolObjects).subscribe();
    }
}
